import React, { Component } from 'react';
import { Redirect, Route, withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

/**
 * Private route component is based off of a Mcginnis post at
 * https://tylermcginnis.com/react-router-protected-routes-authentication/
 *
 * Basically, the goal is to centralize 'protecting' a route to this component
 * so that route components can assume the user is signed in successfully. The only
 * place that PrivateRoute should be used is the top level App component, as
 * sub routes won't be updated correctly.
 *
 * As per other notes, this only works in a maintainable fassion if by
 * convention the App component is the ONLY place where ProtectedRoutes are
 * defined, and this component is the ONLY place session level auth
 * is checked.
 *
 * You have been warned - Cooper, the vengeful.
 */
class ProtectedRoute extends Component {
  componentDidMount() {
  }

  render() {
    const { component } = this.props;
    const ProtectedComponent = component;
    const rest = { ...this.props, component: undefined };
    return (
      <Route
        {...rest}
        render={props => (
          rest.signedIn
            ? <ProtectedComponent {...props} />
            : (
              <Redirect
                to={{
                  pathname: '/signin',
                  state: { from: props.location },
                }}
              />
            )
        )}
      />
    );
  }
}

ProtectedRoute.propTypes = {
  component: PropTypes.func.isRequired,
  signedIn: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  signedIn: state.session.signedIn,
});

const mapDispatchToProps = dispatch => bindActionCreators({
}, dispatch);

// the withRouter here is necessary because the 'child routes' in app
// weren't reacting to location changes because they weren't recieving props
// from react router, see
// https://github.com/ReactTraining/react-router/blob/master/packages/react-router/docs/guides/redux.md
export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProtectedRoute));
